module.exports = __webpack_public_path__ + "static/media/self-interview-values.1450c92b.mp4";